import * as React from 'react';
import { FooterComponent } from '../../components/common/footer/footer.component';
import styles from './getStarted.module.css';
import seconfImg from './Images/images2.png';
import secondImgMobile from './Images/secondImg.png';
import thirdImg from './Images/image3.png';
import thirdImgMobile from './Images/thirdImg.png';
import financialImg from './Images/financialJourney.png';
import check from './Images/check.png';
import { Link } from 'react-router-dom';
import { RemoteData } from '@assetmark/ui-kit/dist/utils/remote-data.utils';
import { none, Option } from 'fp-ts/lib/Option';
import { TGetStartedImage } from '../../models/GetStartedImage.model';
import { useApp } from '../../contexts/app/app.context';
import { ResourceApi } from '../../apis/resource.api';
import { getAzureResource, getBase64ImageFromUrl } from '../../helpers/resource.helper';
import { useEffect, useState } from 'react';
import FullPageLoader from '../../components/common/full-page-loader/fullPageLoader';
import { getLogoPath } from '../../helpers/analysis.helper';

type TImgUrl = {
	imageUrl1: Option<string>;
	imageUrl2: Option<string>;
};

type TGetStartedProps = {
	pageSetting: RemoteData<{
		image1: number;
		image2: number;
	}>;
	images: RemoteData<TGetStartedImage[]>;
	imagesUrl: RemoteData<TImgUrl>;
};
export const GetStarted: React.FC<TGetStartedProps> = ({ imagesUrl }) => {
	const { applicationState } = useApp();
	const [imgOne, setImgOne] = useState("");
	const [imgTwo, setImgTwo] = useState("");
	const [imgAdvisorLogo, setImgAdvisorLogo] = useState("");
	const financeMessage = [
		'Customized Portfolios Targeted To You',
		'Track Your Goals',
		'Build For Your Financial Future',
	];

	// //ResourceApi.getResource("/api/das/v1/Resources?url=https%3A%2F%2Fazncd01edhadl1.blob.core.windows.net%2Friskprofileimages%2Frisk-profile-1_Medium.png");
	// const d = async () => await getBase64ImageFromUrl("/api/das/v1/Resources?url=https%3A%2F%2Fazncd01edhadl1.blob.core.windows.net%2Friskprofileimages%2Frisk-profile-1_Medium.png");
	// d().then(console.log);
	const imgUrls: TImgUrl = imagesUrl.isSuccess() ? imagesUrl.value : { imageUrl1: none, imageUrl2: none };
	useEffect(() => {
		if(imagesUrl.isSuccess()) {
			getAzureResource(imagesUrl.value.imageUrl1.getOrElse("")).then(d => setImgOne(d));
			getAzureResource(imagesUrl.value.imageUrl2.getOrElse("")).then(d => setImgTwo(d));
		}
	}, [imagesUrl]);

	useEffect(() => {
		if(applicationState.advisorLogo.isSome()) {
			const path = getLogoPath(applicationState.advisorLogo);
			path && getAzureResource(path).then(d => setImgAdvisorLogo(d));
			// const logoPath = applicationState.advisorLogo.getOrElse("");
			// if(logoPath) {
			// 	const path = logoPath.split("path=");
			// 	if(path[1]) {
			// 		console.log('path[1] :>> ', path[1]);
			// 		 // getAzureResource(encodeURI(`/api/das/v1/Resources/downloadlogo?path=${path[1]}`)).then(d => setImgAdvisorLogo(d));
			// 	}
			// }	
		}
	}, [applicationState.advisorLogo]);

	let scndImage = '';
	let thrdImage = '';
	if (window.innerWidth <= 576) {
		scndImage = secondImgMobile;
		thrdImage = thirdImgMobile;
	} else {
		scndImage = seconfImg;
		thrdImage = thirdImg;
	}
	
	if (!imagesUrl.isSuccess()) {
		return <FullPageLoader />;
	}
	return (
		<div>
			<div className={styles.startBlock}>
				<div className={styles.imageContainer}>
					<div className={styles.firstcontent}>
						<div className={styles.logo}>
							{ applicationState.isLogoPreferred.getOrElse(false) && applicationState.advisorLogo.getOrElse('') ? 
							 <img data-ot-ignore src={imgAdvisorLogo} /> :
							 <p>{applicationState.wordMark.getOrElse('')}</p>
							}
						</div>
						<div className={styles.plan}>Plan your future.</div>
						<div className={styles.enjoy}>Enjoy life to the fullest.</div>
						<div className={styles.invest}>
							Invest your savings to achieve your financial goals while still managing risks effectively.{' '}
						</div>
						<div className={styles.tell}>
							Tell us about yourself so we can determine the best path forward.
						</div>
						<div className={styles.start}>
							<span>
								<Link to={`/start/about`}>GET STARTED</Link>
							</span>
						</div>
					</div>
					{imgOne && (<img data-ot-ignore src={imgOne} style={{ height: '690px' }} className={styles.firstImage} />)}
				</div>
				<div className={styles.imageContainer}>
					<div className={styles.firstcontent}>
						<div className={styles.finance}>
							<img src={financialImg} />
						</div>
						<div>
							{financeMessage.map((val, index) => (
								<div className={styles.financeMessageContainer} key={`message${index}`}>
									<div className={styles.tick}>
										<img src={check} />
									</div>
									<div className={styles.message}>{val}</div>
								</div>
							))}
						</div>
					</div>
					{/* <img src={seconfImg} style={{ height: '685px' }} className={styles.secondImg} /> */}
					<img src={scndImage} style={{ height: '685px' }} className={styles.secondImg} />
				</div>
				<div className={styles.imageContainer}>
					<div className={styles.firstcontent}>
						<div className={styles.access}>Get access to diversified portfolios</div>
						<div className={styles.accessInfo}>
							Diversified portfolios can help you meet your goals and are designed to reduce deep declines that have historically occurred during market downturns.
						</div>
					</div>
					{/* <img src={thirdImg} style={{ height: '605px' }} className={styles.thirdImg}/> */}
					<img src={thrdImage} style={{ height: '605px' }} className={styles.thirdImg}/>
				</div>
				<div className={`${styles.imageContainer} ${styles.lastImageContainer}`}>
					<div className={styles.firstcontent}>
						<div className={styles.built}>Built for your financial future</div>
						<div className={styles.builtInfo}>
							It’s tough to know what the future may hold. We make it easy to imagine what’s possible and
							help invest for what’s to come.
						</div>
						<div className={`${styles.start} ${styles.lastStart}`}>
							<span>
								<Link to={`/start/about`}>GET STARTED</Link>
							</span>
						</div>
					</div>
					{ imgTwo && (<img data-ot-ignore src={imgTwo} style={{ height: '690px' }} className={styles.lastImage} />)}
				</div>
				<FooterComponent containerClass={styles.footerStyle} />
			</div>
			
		</div>
	);
};
